<template>
    <main v-if="this.showForecast">
        <vs-row class="dashboard-table forecast-view">
            <vs-col
                    vs-type="flex"
                    class="left-table lft-view"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                    vs-xs="12"
            >
                <relations/>
            </vs-col>
            <vs-col
                    vs-type="flex"
                    class="right-table rht-view"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                    vs-xs="12"
            >
                <allocations/>
            </vs-col>
        </vs-row>
    </main>
</template>

<script>
    import settings from "../../config/settings";
    import _ from "lodash";

    const Relations = () => import("./forecast/Relations");
    const Allocations = () => import("./forecast/Allocations");

    export default {
        name: "Forecast",
        components: {
            Allocations,
            Relations
        },
        computed: {
            filter: function () {
                return this.$store.state.forecast.filter;
            },
            podioUser: function() {
                return this.$store.state.auth.podio_user;
            },
            showForecast: function() {
                // if (this.podioUser.canAccessQForecastForecasting === true) {
                //     this.canAccessQForecastForecasting = true;
                // }
                return this.podioUser.canAccessQForecastForecasting || false;
            }
        },
        beforeMount() {
            if (this.showForecast) {
                this.requestApis();
            }
            //this.requestApis();
        },
        methods: {
            /**
             * Init all api requests
             */
            requestApis: function () {
                // set the row count to initial value
                let filter = _.cloneDeep(this.filter);
                filter.pageSize = settings.initial_forecast_row_count;
                filter.pageNumber = 1;
                // fetch the forecast data
                this.$store.dispatch("fetchForecast", filter);
                // fetch the forecast result
                this.$store.dispatch("fetchForecastResult", filter);
                // fetch the OE country list
                this.$store.dispatch("fetchOECountryList");
            }
        },
        watch: {
            showForecast: function() {
                if (this.showForecast) {
                    this.requestApis();
                }
            }
        }
    };
</script>

<style scoped>

</style>
